// extracted by mini-css-extract-plugin
export default {"root":"PillTabs_root__JS3Wy","tab":"PillTabs_tab__N5lqW","tabActive":"PillTabs_tabActive__leT4q"};